import moment from 'moment-timezone';
import {
  INITIAL_LOAD,
  LOAD_TRACKING_DATA_FOR_DASHBOARD,
  REQUEST_TRACKING_STATS_FOR_MONTH_AND_YEAR,
  REQUEST_WORKOUT_STATS_FOR_DASHBOARD_SUCCESS,
  REQUEST_TRACKING_STATS_FAILED,
  REQUEST_WORKOUT_STATS,
  REQUEST_WORKOUT_STATS_SUCCESS,
  REQUEST_SCAN_STATS,
  REQUEST_SCAN_STATS_SUCCESS,
  REQUEST_SCAN_STAT_DATES_SUCCESS,
  REQUEST_LATEST_SCAN_STATS,
  REQUEST_LATEST_SCAN_STATS_SUCCESS,
  RELOAD_SCAN_STATS_FOR_DASHBOARD,
  SET_SELECTED_SCAN_STATS_DATE,
  REQUEST_WORKOUT_STATS_FAILED,
  TRACKING_WORKOUT_DATE_CHANGE,
  TRACKING_WORKOUT_DETAIL_OPENED,
  TRACKING_HEALTH_DETAIL_OPENED,
  TRACKING_HEALTH_DATE_CHANGE,
  TRACKING_MAIN_TILE_SELECTED,
  TRACKING_WORKOUTS_HISTORY_OPENED,
  TRACKING_HEALTH_HISTORY_OPENED,
  TRACKING_WORKOUTS_HISTORY_WORKOUTOPENED,
  SHOP_FOR_FITBEAT_GEAR_SELECTED,
  REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_SUCCESS,
  REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_FAILED,
  REQUEST_WEEKLY_WORKOUT_STATS_REQUEST,
  REQUEST_WEEKLY_WORKOUT_STATS_SUCCESS,
  REQUEST_WEEKLY_WORKOUT_STATS_FAILURE,
  REQUEST_BODY_METRIC_STATS_REQUEST,
  REQUEST_BODY_METRIC_STATS_SUCCESS,
  REQUEST_BODY_METRIC_STATS_FAILURE,
  LOAD_LEADERBOARDS_REQUEST,
  LOAD_LEADERBOARDS_SUCCESS,
  LOAD_LEADERBOARDS_FAILURE,
  LOAD_INACTIVE_LEADERBOARDS_REQUEST,
  LOAD_INACTIVE_LEADERBOARDS_SUCCESS,
  LOAD_INACTIVE_LEADERBOARDS_FAILURE,
  OPT_OUT_OF_LEADERBOARD,
  OPT_OUT_OF_LEADERBOARD_FAILURE,
  OPT_OUT_OF_LEADERBOARD_REQUEST,
  OPT_OUT_OF_LEADERBOARD_SUCCESS,
  CLOSE_OPT_OUT_LEADERBOARD_MODAL,
  LOAD_USER_BREAKDOWN_REQUEST,
  LOAD_USER_BREAKDOWN_SUCCESS,
  LOAD_USER_BREAKDOWN_FAILURE,
} from './actionTypes';
import { analyicsForAction } from '../services/google-analytics/analyicsForAction';

const initialLoad = (now) => ({
  type: INITIAL_LOAD,
  payload: {
    now,
  },
});

const requestTrackingStats = (now, month, year) => ({
  type: REQUEST_TRACKING_STATS_FOR_MONTH_AND_YEAR,
  payload: {
    now,
    month,
    year,
  },
});

const requestWorkoutStats = (now, month, year) => ({
  type: REQUEST_WORKOUT_STATS,
  payload: {
    now,
    month,
    year,
  },
});

const requestWorkoutStatsSuccess = (workoutStats) => ({
  type: REQUEST_WORKOUT_STATS_SUCCESS,
  payload: {
    workoutStats,
  },
});

const requestScanStats = (now, date) => ({
  type: REQUEST_SCAN_STATS,
  payload: {
    now,
    date,
  },
});

const requestLatestScanStats = (now, date) => ({
  type: REQUEST_LATEST_SCAN_STATS,
  payload: {
    now,
    date,
  },
});
const requestLatestScanStatsSuccess = (scanStats) => ({
  type: REQUEST_LATEST_SCAN_STATS_SUCCESS,
  payload: {
    scanStats,
  },
});

const requestScanStatsSuccess = (scanStats) => ({
  type: REQUEST_SCAN_STATS_SUCCESS,
  payload: {
    scanStats,
  },
});

const requestTrackingStatsFailed = (error) => ({
  type: REQUEST_TRACKING_STATS_FAILED,
  payload: {
    error,
  },
});

const requestWorkoutStatsForDashboardSuccess = (workoutStats) => ({
  type: REQUEST_WORKOUT_STATS_FOR_DASHBOARD_SUCCESS,
  payload: {
    ...workoutStats,
  },
});

const requestWorkoutStatsFailed = (error) => ({
  type: REQUEST_WORKOUT_STATS_FAILED,
  payload: {
    error,
  },
});

const requestWeeklyWorkoutProgressForGraphSuccess = (weeklyProgress) => ({
  type: REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_SUCCESS,
  payload: weeklyProgress,
});
const requestWeeklyWorkoutProgressForGraphFailure = (error) => ({
  type: REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_FAILED,
  payload: error,
});

const requestWeeklyWorkoutStatsData = () => ({
  type: REQUEST_WEEKLY_WORKOUT_STATS_REQUEST,
});

const requestWeeklyWorkoutStatsDataSuccess = (weeklyStats) => ({
  type: REQUEST_WEEKLY_WORKOUT_STATS_SUCCESS,
  payload: weeklyStats,
});

const requestWeeklyWorkoutStatsDataFailure = (error) => ({
  type: REQUEST_WEEKLY_WORKOUT_STATS_FAILURE,
  payload: error,
});
export const requestBodyMetricStats = () => ({
  type: REQUEST_BODY_METRIC_STATS_REQUEST,
});

export const requestBodyMetricStatsSuccess = (bodyMetricSet) => ({
  type: REQUEST_BODY_METRIC_STATS_SUCCESS,
  payload: bodyMetricSet,
});

export const loadTrackingDataForDashboardSuccess = (bodyMetricSet, target) => ({
  type: LOAD_TRACKING_DATA_FOR_DASHBOARD,
  payload: {
    bodyMetricSet,
    target,
  },
});

export const requestBodyMetricStatsFailure = (error) => ({
  type: REQUEST_BODY_METRIC_STATS_FAILURE,
  payload: error,
});

const requestScanStatDatesSuccess = (scanStats) => ({
  type: REQUEST_SCAN_STAT_DATES_SUCCESS,
  payload: {
    scanStats,
  },
});

const setSelectedScanStatsDate = (date) => ({
  type: SET_SELECTED_SCAN_STATS_DATE,
  payload: {
    date,
  },
});

export const reloadScanStatsForDashboard = (scanStats) => ({
  type: RELOAD_SCAN_STATS_FOR_DASHBOARD,
  payload: {
    ...scanStats,
  },
});

const loadLeaderboardsRequest = () => ({
  type: LOAD_LEADERBOARDS_REQUEST,
});

const loadLeaderboardsSuccess = (leaderboards) => ({
  type: LOAD_LEADERBOARDS_SUCCESS,
  payload: leaderboards,
});

const loadLeaderboardsFailure = () => ({
  type: LOAD_LEADERBOARDS_FAILURE,
});

const loadInactiveLeaderboardsRequest = () => ({
  type: LOAD_INACTIVE_LEADERBOARDS_REQUEST,
});

const loadInactiveLeaderboardsSuccess = (inactiveLeaderboards) => ({
  type: LOAD_INACTIVE_LEADERBOARDS_SUCCESS,
  payload: inactiveLeaderboards,
});

const loadInactiveLeaderboardsFailure = () => ({
  type: LOAD_INACTIVE_LEADERBOARDS_FAILURE,
});

const loadUserBreakdownRequest = () => ({
  type: LOAD_USER_BREAKDOWN_REQUEST,
});

const loadUserBreakdownSuccess = (userBreakdown) => ({
  type: LOAD_USER_BREAKDOWN_SUCCESS,
  payload: userBreakdown,
});

const loadUserBreakdownFailure = (error) => ({
  type: LOAD_USER_BREAKDOWN_FAILURE,
  payload: !!error,
});

export const optOutOfLeaderboardRequest = () => ({
  type: OPT_OUT_OF_LEADERBOARD_REQUEST,
});

export const optOutOfLeaderboardSuccess = () => ({
  type: OPT_OUT_OF_LEADERBOARD_SUCCESS,
});

export const optOutOfLeaderboardFailure = (error) => ({
  type: OPT_OUT_OF_LEADERBOARD_FAILURE,
  payload: error,
});

export const loadInitialStateForDashboard = (userService, now) => async (dispatch) => {
  dispatch(initialLoad(now));
  const month = Number(moment(now).format('M'));
  const year = Number(moment(now).format('YYYY'));
  const datestamp = now.valueOf();
  const timezone = moment.tz.guess();

  userService.getWorkoutStatsForUser(year, month)
    .then((x) => dispatch(requestWorkoutStatsForDashboardSuccess(x)))
    .catch((e) => dispatch(requestWorkoutStatsFailed(e)));

  userService.getWeeklyWorkoutProgressData(datestamp, timezone)
    .then((x) => dispatch(requestWeeklyWorkoutProgressForGraphSuccess(x)))
    .catch((e) => dispatch(requestWeeklyWorkoutProgressForGraphFailure(e)));

  requestWeeklyWorkoutStatsData();
  userService.getWeeklyWorkoutStatsData(datestamp, timezone)
    .then((x) => dispatch(requestWeeklyWorkoutStatsDataSuccess(x)))
    .catch((e) => dispatch(requestWeeklyWorkoutStatsDataFailure(e)));

  userService.getTargetAndBodyMetricSetForUser(datestamp, timezone)
    .then((x) => dispatch(loadTrackingDataForDashboardSuccess(x.bodyMetricSet, x.weightTargetInfo)))
    .catch((e) => dispatch(requestBodyMetricStatsFailure(e)));
};

export const loadInitialStateForWorkoutStats = (userService, now) => async (dispatch) => {
  dispatch(initialLoad(now));
  const month = Number(moment(now).format('M'));
  const year = Number(moment(now).format('YYYY'));

  try {
    const response = await userService.getWorkoutStatsForUser(year, month);
    dispatch(requestWorkoutStatsSuccess(response.workoutStats));
    dispatch(trackingWorkoutsDetailTabSelected());
  } catch (error) {
    dispatch(requestTrackingStatsFailed(error));
  }
};

export const loadInitialStateAndLatestScan = (userService, now) => async (dispatch) => {
  dispatch(initialLoad(now));

  try {
    const scanStatDates = await userService.getMyBodyScans();
    dispatch(requestScanStatDatesSuccess(scanStatDates));

    const datestamp = now.valueOf();
    const timezone = moment.tz.guess();
    const response = await userService.getScanStatsForUser(datestamp, timezone);

    if (response && response.scanStats) {
      const lastScanDate = moment(response.scanStats.scanDate);
      const currentDate = moment(now);
      dispatch(trackingHealthDetailTabSelected());
      if (!currentDate.isSame(lastScanDate, 'day')) {
        dispatch(requestLatestScanStats(now, lastScanDate.toDate()));
        const lastScanDatestamp = lastScanDate.valueOf();
        const latest = await userService.getScanStatsForUser(lastScanDatestamp, timezone);
        dispatch(requestLatestScanStatsSuccess(latest.scanStats));
        return;
      }
      dispatch(setSelectedScanStatsDate(lastScanDate.toDate()));
    }
    dispatch(requestScanStatsSuccess(response.scanStats));
  } catch (error) {
    dispatch(requestTrackingStatsFailed(error));
  }
};

export const getWorkoutStats = (userService, now, date) => async (dispatch) => {
  const month = Number(moment(date).format('M'));
  const year = Number(moment(date).format('YYYY'));

  dispatch(requestWorkoutStats(now, month, year));

  try {
    const response = await userService.getWorkoutStatsForUser(year, month);
    dispatch(requestWorkoutStatsSuccess(response.workoutStats));
    dispatch(trackingWorkoutDetailDateChange());
  } catch (error) {
    dispatch(requestTrackingStatsFailed(error));
  }
};

export const getScanStats = (userService, now, date) => async (dispatch) => {
  const fullDate = new Date(date);
  dispatch(requestScanStats(now, fullDate));

  try {
    const datestamp = fullDate.valueOf();
    const timezone = moment.tz.guess();
    const response = await userService.getScanStatsForUser(datestamp, timezone);
    dispatch(requestScanStatsSuccess(response.scanStats));
    dispatch(trackingHealthDetailDateChange());
  } catch (error) {
    dispatch(requestTrackingStatsFailed(error));
  }
};

export const loadUserBreakdownForLeaderboard = (
  userService,
  userProfileId,
  leaderboardConfigId,
  startDate,
  endDate,
  team,
) => async (dispatch) => {
  dispatch(loadUserBreakdownRequest());
  try {
    const response = await userService.getLeaderboardBreakdownForUser(
      userProfileId,
      leaderboardConfigId,
      startDate,
      endDate,
      team,
    );
    dispatch(loadUserBreakdownSuccess(response));
  } catch (error) {
    dispatch(loadUserBreakdownFailure(error));
  }
};

export const loadLeaderboardsForUser = (userService) => async (dispatch) => {
  dispatch(loadLeaderboardsRequest());
  try {
    const response = await userService.getLeaderboardsForUser();
    dispatch(loadLeaderboardsSuccess(response));
  } catch (error) {
    dispatch(loadLeaderboardsFailure(error));
  }
};

export const loadInactiveLeaderboardsForUser = (userService, viewOption) => async (dispatch) => {
  dispatch(loadInactiveLeaderboardsRequest());
  try {
    const response = await userService.getInactiveLeaderboardsForUser(viewOption);
    dispatch(loadInactiveLeaderboardsSuccess(response));
  } catch (error) {
    dispatch(loadInactiveLeaderboardsFailure(error));
  }
};

export const confirmOptOutOfLeaderboard = (
  userService,
  leaderboard,
  navigation,
) => async (dispatch) => {
  dispatch(optOutOfLeaderboardRequest());
  try {
    await userService.optOutOfLeaderboard(
      leaderboard.leaderboardId,
    );

    await dispatch(loadLeaderboardsForUser(userService));
    await navigation.navigate('ChallengesTab');

    dispatch(optOutOfLeaderboardSuccess());
  } catch (error) {
    dispatch(optOutOfLeaderboardFailure(error));
  }
};

export const optOutOfLeaderboard = (leaderboard) => ({
  type: OPT_OUT_OF_LEADERBOARD,
  payload: {
    leaderboard,
  },
});

export const closeOptOutLeaderboardModal = () => ({
  type: CLOSE_OPT_OUT_LEADERBOARD_MODAL,
});

export const trackingWorkoutDetailDateChange = () => ({
  type: TRACKING_WORKOUT_DATE_CHANGE,
  ...analyicsForAction(TRACKING_WORKOUT_DATE_CHANGE),
});

export const trackingHealthDetailDateChange = () => ({
  type: TRACKING_HEALTH_DATE_CHANGE,
  ...analyicsForAction(TRACKING_HEALTH_DATE_CHANGE),
});

export const trackingWorkoutsDetailTabSelected = () => ({
  type: TRACKING_WORKOUT_DETAIL_OPENED,
  ...analyicsForAction(TRACKING_WORKOUT_DETAIL_OPENED),
});

export const trackingHealthDetailTabSelected = () => ({
  type: TRACKING_HEALTH_DETAIL_OPENED,
  ...analyicsForAction(TRACKING_HEALTH_DETAIL_OPENED),
});

export const trackingTileSelected = (tileName) => {
  const analyicsEventMap = {
    'Workout Performance l': 'tracking_workoutstile_selected',
    'Body Composition': 'tracking_heathtile_selected',
    Nutrition: 'tracking_nutritiontile_selected',
  };

  return {
    type: TRACKING_MAIN_TILE_SELECTED,
    ...analyicsForAction(analyicsEventMap[tileName]),
  };
};

export const trackingHealthHistoryTabSelected = () => ({
  type: TRACKING_HEALTH_HISTORY_OPENED,
  ...analyicsForAction(TRACKING_HEALTH_HISTORY_OPENED),
});

export const trackingWorkoutsHistoryTabSelected = () => ({
  type: TRACKING_WORKOUTS_HISTORY_OPENED,
  ...analyicsForAction(TRACKING_WORKOUTS_HISTORY_OPENED),
});

export const openTrackingWorkoutHistoryModal = () => ({
  type: TRACKING_WORKOUTS_HISTORY_WORKOUTOPENED,
  ...analyicsForAction(TRACKING_WORKOUTS_HISTORY_WORKOUTOPENED),
});

export const shopForFitbeatGearSelected = () => ({
  type: SHOP_FOR_FITBEAT_GEAR_SELECTED,
  ...analyicsForAction(SHOP_FOR_FITBEAT_GEAR_SELECTED),
});
